import { render } from "./LuckyWheel.vue?vue&type=template&id=2b268462&scoped=true"
import script from "./LuckyWheel.vue?vue&type=script&lang=js"
export * from "./LuckyWheel.vue?vue&type=script&lang=js"

import "./LuckyWheel.vue?vue&type=style&index=0&id=2b268462&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b268462"]])

export default __exports__